var n;!function(n){n.API_RESPONSE="nrApiResponse",n.EVENT="nrEvent",n.TIMEOUT="nrTimeout"}(n||(n={}));export{n as NewRelicEventType};
